(() => {
  'use strict';

  document.documentElement.dataset.gemmariiRuntimeBuild = '20260914-2230';

  const defineGemmariiChoice = () => {
    if (customElements.get('gemmarii-choice')) return;

    customElements.define('gemmarii-choice', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.mainProduct') || this.closest('.shopify-section') || document;
        try {
          this.values = JSON.parse(this.dataset.values || '{}');
        } catch (_) {
          this.values = {};
        }
        this.updateChoice();
      }

      updateChoice() {
        const name = this.dataset.optionName;
        if (!name || !this.root) return;

        const list = Array.from(this.root.querySelectorAll('.variant-options'))
          .find((element) => element.dataset.optionName === name);
        const selected = list?.querySelector('.variant-option-item.selected, [aria-checked="true"], [aria-selected="true"]');
        const select = Array.from(this.root.querySelectorAll('select'))
          .find((element) => element.name === `options[${name}]` || element.dataset.optionName === name);
        const value = selected?.dataset.swatch ?? selected?.querySelector('input')?.value ?? select?.value;
        const text = this.values[value];
        if (text !== undefined && this.textContent !== text) this.textContent = text;
      }
    });
  };

let gemmariiProductSelectId = 0;

  const defineGemmariiProductSelect = () => {
    if (customElements.get('gemmarii-product-select')) return;

    customElements.define('gemmarii-product-select', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.gemmariiReady === 'true') return;
        this.select = this.querySelector(':scope > select');
        if (!this.select) return;

        this.dataset.gemmariiReady = 'true';
        this.dataset.enhanced = 'true';
        gemmariiProductSelectId += 1;

        this.trigger = document.createElement('button');
        this.trigger.type = 'button';
        this.trigger.className = 'gemmarii-product-select__trigger';
        this.trigger.id = `GemmariiProductSelect-${gemmariiProductSelectId}`;
        this.trigger.setAttribute('aria-haspopup', 'listbox');
        this.trigger.setAttribute('aria-expanded', 'false');

        this.valueNode = document.createElement('span');
        this.valueNode.className = 'gemmarii-product-select__value';
        this.trigger.append(this.valueNode);

        this.menu = document.createElement('div');
        this.menu.className = 'gemmarii-product-select__menu';
        this.menu.id = `${this.trigger.id}-listbox`;
        this.menu.setAttribute('role', 'listbox');
        this.menu.hidden = true;
        this.trigger.setAttribute('aria-controls', this.menu.id);

        Array.from(this.select.options).forEach((option, index) => {
          if (option.disabled && !option.value) return;
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'gemmarii-product-select__option';
          item.dataset.optionIndex = String(index);
          item.setAttribute('role', 'option');
          item.textContent = option.textContent;
          item.disabled = option.disabled;
          item.tabIndex = -1;
          this.menu.append(item);
        });

        this.append(this.trigger, this.menu);
        this.select.dataset.gemmariiNativeSelect = 'true';
        this.select.tabIndex = -1;
        this.select.setAttribute('aria-hidden', 'true');

        if (this.select.id) {
          const label = this.parentElement?.querySelector(`label[for="${CSS.escape(this.select.id)}"]`);
          if (label) {
            this.labelText = label.textContent.trim();
            label.setAttribute('for', this.trigger.id);
          }
        }

        this.onTriggerClick = () => {
          if (this.menu.hidden) this.open();
          else this.close();
        };
        this.onTriggerKeydown = (event) => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            this.open(event.key === 'ArrowUp');
          } else if (event.key === 'Escape') {
            this.close();
          }
        };
        this.onMenuClick = (event) => {
          const item = event.target.closest('.gemmarii-product-select__option');
          if (item) this.choose(item);
        };
        this.onMenuKeydown = (event) => {
          const items = this.items();
          const current = event.target.closest('.gemmarii-product-select__option');
          if (!current || !items.length) return;
          const index = Math.max(0, items.indexOf(current));

          if (event.key === 'Escape') {
            event.preventDefault();
            this.close(true);
            return;
          }
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.choose(current);
            return;
          }
          if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = items.length - 1;
          else if (event.key === 'ArrowDown') nextIndex = (index + 1) % items.length;
          else nextIndex = (index - 1 + items.length) % items.length;
          items[nextIndex]?.focus();
        };
        this.onSelectChange = () => this.sync();
        this.onDocumentPointerDown = (event) => {
          if (!this.contains(event.target)) this.close();
        };

        this.trigger.addEventListener('click', this.onTriggerClick);
        this.trigger.addEventListener('keydown', this.onTriggerKeydown);
        this.menu.addEventListener('click', this.onMenuClick);
        this.menu.addEventListener('keydown', this.onMenuKeydown);
        this.select.addEventListener('change', this.onSelectChange);
        document.addEventListener('pointerdown', this.onDocumentPointerDown, true);

        this.sync();
        if (document.activeElement === this.select) {
          requestAnimationFrame(() => this.trigger?.focus({ preventScroll: true }));
        }
      }

      disconnectedCallback() {
        document.removeEventListener('pointerdown', this.onDocumentPointerDown, true);
      }

      items() {
        return Array.from(this.menu?.querySelectorAll('.gemmarii-product-select__option:not(:disabled)') || []);
      }

      sync() {
        const selected = this.select?.options[this.select.selectedIndex];
        if (!selected || !this.valueNode) return;
        this.valueNode.textContent = selected.textContent;
        this.trigger.setAttribute('aria-label', this.labelText ? `${this.labelText}: ${selected.textContent}` : selected.textContent);
        this.menu?.querySelectorAll('.gemmarii-product-select__option').forEach((item) => {
          const active = Number(item.dataset.optionIndex) === this.select.selectedIndex;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-selected', String(active));
        });
      }

      open(focusLast = false) {
        if (!this.menu || !this.trigger) return;
        const rect = this.trigger.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;
        const openAbove = spaceBelow < 260 && spaceAbove > spaceBelow;
        const available = Math.max(160, Math.min(360, (openAbove ? spaceAbove : spaceBelow) - 16));

        this.classList.toggle('is-above', openAbove);
        this.classList.add('is-open');
        this.menu.style.maxHeight = `${available}px`;
        this.menu.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');

        requestAnimationFrame(() => {
          const items = this.items();
          const selected = items.find((item) => item.getAttribute('aria-selected') === 'true');
          const target = focusLast ? items[items.length - 1] : selected || items[0];
          target?.focus({ preventScroll: true });
          selected?.scrollIntoView({ block: 'nearest' });
        });
      }

      close(restoreFocus = false) {
        if (!this.menu || this.menu.hidden) return;
        this.menu.hidden = true;
        this.classList.remove('is-open', 'is-above');
        this.trigger?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.trigger?.focus({ preventScroll: true });
      }

      choose(item) {
        const index = Number(item.dataset.optionIndex);
        const option = this.select?.options[index];
        if (!option || option.disabled) return;

        this.select.selectedIndex = index;
        Array.from(this.select.options).forEach((entry, optionIndex) => {
          entry.toggleAttribute('selected', optionIndex === index);
        });
        this.sync();
        this.close(true);
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  const enhanceGemmariiProductSelects = (root = document) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const selector = 'variant-selector select:not([data-gemmarii-customized])';
    const selects = root.matches?.(selector)
      ? [root]
      : Array.from(root.querySelectorAll?.(selector) || []);

    selects.forEach((select) => {
      if (select.closest('gemmarii-product-select')) return;
      const parent = select.parentNode;
      if (!parent) return;
      const next = select.nextSibling;
      const wrapper = document.createElement('gemmarii-product-select');
      select.dataset.gemmariiCustomized = 'true';
      wrapper.append(select);
      parent.insertBefore(wrapper, next);
    });
  };

    let choiceRefreshScheduled = false;
  const refreshGemmariiChoices = () => {
    if (choiceRefreshScheduled) return;
    choiceRefreshScheduled = true;
    requestAnimationFrame(() => {
      choiceRefreshScheduled = false;
      document.querySelectorAll('gemmarii-choice').forEach((choice) => choice.updateChoice?.());
    });
  };

  const variantItems = (source) => {
    if (!source) return [];
    if (typeof source.querySelectorAll === 'function') {
      return Array.from(source.querySelectorAll('.variant-option-item'));
    }
    try {
      return Array.from(source).filter((item) => item?.classList?.contains('variant-option-item'));
    } catch (_) {
      return [];
    }
  };

  const normalizeVariantARIA = (root = document) => {
    root.querySelectorAll?.('variant-selector .variant-options').forEach((group) => {
      const items = variantItems(group);
      if (!items.length) return;

      group.setAttribute('role', 'radiogroup');
      group.removeAttribute('aria-multiselectable');

      const selectedItem = items.find((item) =>
        item.classList.contains('selected')
        || item.getAttribute('aria-checked') === 'true'
        || item.querySelector('input[type="radio"]')?.checked
      );
      const focusableItem = selectedItem
        || items.find((item) => item.getAttribute('tabindex') === '0')
        || items[0];

      items.forEach((item) => {
        const selected = item === selectedItem;
        item.setAttribute('role', 'radio');
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
        item.removeAttribute('aria-selected');
        item.setAttribute('tabindex', item === focusableItem ? '0' : '-1');
        const input = item.querySelector('input[type="radio"]');
        if (input) input.checked = selected;
      });
    });
  };

  const patchThemeComponents = () => {
    const VariantSelector = customElements.get('variant-selector');
    if (VariantSelector && !VariantSelector.prototype.gemmariiRuntimePatched) {
      VariantSelector.prototype.onDropdownChange = function () {};

      VariantSelector.prototype.updateARIAStates = function (source, selectedItem) {
        const items = variantItems(source);
        const group = selectedItem?.closest?.('.variant-options')
          || source?.closest?.('.variant-options')
          || null;
        group?.setAttribute('role', 'radiogroup');

        items.forEach((item) => {
          const selected = item === selectedItem;
          item.setAttribute('role', 'radio');
          item.setAttribute('aria-checked', selected ? 'true' : 'false');
          item.removeAttribute('aria-selected');
          item.setAttribute('tabindex', selected ? '0' : '-1');
          item.classList.toggle('selected', selected);
          const input = item.querySelector('input[type="radio"]');
          if (input) input.checked = selected;
        });
      };

      VariantSelector.prototype.gemmariiRuntimePatched = true;
    }

    const QuantityEditor = customElements.get('quantity-editor');
    if (QuantityEditor && !QuantityEditor.prototype.gemmariiRuntimePatched) {
      QuantityEditor.prototype.editQuantity = function (input, increment) {
        if (!input) return;
        if (increment) input.stepUp();
        else input.stepDown();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      QuantityEditor.prototype.gemmariiRuntimePatched = true;
    }
  };

  const handleVariantKeyboard = (event) => {
    const item = event.target.closest?.('variant-selector .variant-option-item');
    if (!item || item.getAttribute('role') !== 'radio') return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopImmediatePropagation();
      item.click();
      queueMicrotask(() => {
        normalizeVariantARIA(item.closest('variant-selector') || document);
        refreshGemmariiChoices();
      });
      return;
    }

    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
    const group = item.closest('.variant-options');
    if (!group) return;

    const items = Array.from(group.querySelectorAll('.variant-option-item[role="radio"]'))
      .filter((option) => !option.classList.contains('disabled') && option.getAttribute('aria-disabled') !== 'true');
    if (!items.length) return;

    const currentIndex = Math.max(0, items.indexOf(item));
    let nextIndex = currentIndex;
    if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = items.length - 1;
    else {
      const direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
      nextIndex = (currentIndex + direction + items.length) % items.length;
    }

    const nextItem = items[nextIndex];
    if (!nextItem) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    nextItem.focus();
    if (nextItem !== item) nextItem.click();
    queueMicrotask(() => {
      normalizeVariantARIA(nextItem.closest('variant-selector') || document);
      refreshGemmariiChoices();
    });
  };

  const handleQuantityClick = (event) => {
    const button = event.target.closest?.('quantity-editor .increment-btn, quantity-editor .decrement-btn');
    if (!button) return;

    const editor = button.closest('quantity-editor');
    const input = editor?.querySelector?.('input[type="number"], input[name="quantity"]');
    if (!editor || !input || typeof editor.editQuantity !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    editor.editQuantity(input, button.classList.contains('increment-btn'));
  };

  const normalizeProductMediaAccessibility = (root = document) => {
    root.querySelectorAll?.('.mainProduct .video-tab-js').forEach((media) => {
      media.setAttribute('tabindex', '-1');
    });
  };

  const prioritizeGalleryMedia = (gallery, mediaId) => {
    if (!gallery || !mediaId) return;
    const slide = Array.from(gallery.querySelectorAll('.media-child[data-media-id]'))
      .find((item) => String(item.dataset.mediaId) === String(mediaId));
    const image = slide?.querySelector('img:not(.gemmarii-zodiac-stone-overlay)');
    if (!image) return;
    image.loading = 'eager';
    image.fetchPriority = 'high';
  };

  const notifySelectedMedia = (gallery) => {
    const mediaId = String(gallery?.dataset?.selectedVariantId || '');
    if (!mediaId) return;
    prioritizeGalleryMedia(gallery, mediaId);
    gallery.dispatchEvent(new CustomEvent('gemmarii:variant-media-selected', {
      bubbles: true,
      detail: { mediaId }
    }));
  };

  const observeProductMediaPriority = (root = document) => {
    root.querySelectorAll?.('wdt-main-media[data-selected-variant-id]').forEach((gallery) => {
      prioritizeGalleryMedia(gallery, gallery.dataset.selectedVariantId);
      if (gallery.dataset.gemmariiPriorityBound === 'true') return;

      gallery.dataset.gemmariiPriorityBound = 'true';
      const observer = new MutationObserver(() => notifySelectedMedia(gallery));
      observer.observe(gallery, { attributes: true, attributeFilter: ['data-selected-variant-id'] });
      gallery.gemmariiPriorityObserver = observer;
    });
  };

  const syncVariantLightbox = (root = document) => {
    const galleries = root.matches?.('wdt-main-media[data-variant-media-filter]')
      ? [root]
      : Array.from(root.querySelectorAll?.('wdt-main-media[data-variant-media-filter]') || []);

    galleries.forEach((gallery) => {
      const allowed = (gallery.dataset.gemmariiAllowedMediaIds || '').split(',').filter(Boolean);
      if (!allowed.length) return;

      gallery.querySelectorAll('.product-media-gallery .media-child').forEach((slide) => {
        const link = slide.querySelector('a[href]');
        if (!link) return;
        const visible = allowed.includes(String(slide.dataset.mediaId || ''));

        link.toggleAttribute('data-gemmarii-lightbox-hidden', !visible);
        link.toggleAttribute('aria-hidden', !visible);
        if (visible) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', '-1');
      });
    });
  };

  const syncProductFormVariantIds = (root = document) => {
    const scopes = root.matches?.('main-product-form')
      ? [root]
      : Array.from(root.querySelectorAll?.('main-product-form') || []);

    scopes.forEach((scope) => {
      const input = scope.querySelector('input[name="id"]');
      if (!input) return;

      let variantId = '';
      const selected = scope.querySelector('[data-selected-variant]');
      if (selected?.textContent) {
        try {
          variantId = String(JSON.parse(selected.textContent).id || '');
        } catch (_) {}
      }

      if (!variantId) {
        variantId = new URLSearchParams(window.location.search).get('variant') || '';
      }
      if (!variantId) {
        variantId = scope.querySelector('variant-selector[data-availabilityid]')?.dataset.availabilityid || '';
      }

      if (variantId) {
        input.value = variantId;
        input.setAttribute('value', variantId);
      }
    });
  };

  const observeProductFormVariantIds = (root = document) => {
    const scopes = root.matches?.('main-product-form')
      ? [root]
      : Array.from(root.querySelectorAll?.('main-product-form') || []);

    scopes.forEach((scope) => {
      if (scope.dataset.gemmariiVariantIdObserver === 'true') return;
      scope.dataset.gemmariiVariantIdObserver = 'true';

      const observer = new MutationObserver(() => {
        requestAnimationFrame(() => syncProductFormVariantIds(scope));
      });
      observer.observe(scope, {
        attributes: true,
        attributeFilter: ['data-availabilityid'],
        childList: true,
        subtree: true
      });
      scope.gemmariiVariantIdObserver = observer;
    });
  };

  const addProductToCart = async (event, button) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.dataset.gemmariiAdding === 'true') return;

    const scope = button.closest('main-product-form');
    syncProductFormVariantIds(scope || document);
    const form = button.closest('form[action*="/cart/add"]');
    const variantId = form?.querySelector('input[name="id"]')?.value;
    const errorNode = scope?.querySelector('#error-message');
    if (!form || !variantId) {
      if (errorNode) errorNode.textContent = 'Vælg venligst en gyldig variant.';
      return;
    }

    button.dataset.gemmariiAdding = 'true';
    button.disabled = true;
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(form)
      });
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.description || result.message || 'Produktet kunne ikke tilføjes.');
      }
      window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } catch (error) {
      console.error('Gemmarii cart add failed:', error);
      if (errorNode) {
        errorNode.textContent = error.message || 'Produktet kunne ikke tilføjes.';
        errorNode.classList.add('alert', 'alert-danger');
      }
      button.disabled = false;
      button.dataset.gemmariiAdding = 'false';
    }
  };

  const refreshProductEnhancements = (root = document) => {
    defineGemmariiChoice();
    defineGemmariiProductSelect();
    enhanceGemmariiProductSelects(root);
    patchThemeComponents();
    syncProductFormVariantIds(root);
    observeProductFormVariantIds(root);
    normalizeVariantARIA(root);
    normalizeProductMediaAccessibility(root);
    observeProductMediaPriority(root);
    refreshGemmariiChoices();
    requestAnimationFrame(() => {
      syncProductFormVariantIds(root);
      syncVariantLightbox(root);
    });
  };

  window.addEventListener('pointerdown', (event) => {
    const button = event.target.closest?.('form[action*="/cart/add"] button[type="submit"][name="add"]');
    if (!button) return;
    void addProductToCart(event, button);
  }, true);

  const bindProductFormSubmit = (root = document) => {
    const selector = 'form[action*="/cart/add"] button[type="submit"][name="add"]';
    const buttons = root.matches?.(selector)
      ? [root]
      : Array.from(root.querySelectorAll?.(selector) || []);
    buttons.forEach((button) => {
      if (button.dataset.gemmariiCartBound === 'true') return;
      button.dataset.gemmariiCartBound = 'true';
      button.addEventListener('click', (event) => addProductToCart(event, button), true);
    });
  };

  bindProductFormSubmit();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        bindProductFormSubmit(node);
        if (node.matches?.('main-product-form') || node.querySelector?.('main-product-form')) {
          refreshProductEnhancements(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  refreshProductEnhancements();

  document.addEventListener('keydown', handleVariantKeyboard, true);
  document.addEventListener('click', handleQuantityClick, true);
  document.addEventListener('click', (event) => {
    const item = event.target.closest?.('variant-selector .variant-option-item[role="radio"]');
    if (!item) return;
    queueMicrotask(() => {
      normalizeVariantARIA(item.closest('variant-selector') || document);
      refreshGemmariiChoices();
    });
  }, true);

  document.addEventListener('gemmarii:variant-media-selected', (event) => {
    const gallery = event.target?.closest?.('wdt-main-media[data-variant-media-filter]') || event.target;
    requestAnimationFrame(() => {
      syncVariantLightbox(gallery?.matches?.('wdt-main-media') ? gallery : document);
      const productForm = gallery?.closest?.('.mainProduct')?.querySelector('main-product-form');
      syncProductFormVariantIds(productForm || document);
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    refreshProductEnhancements(event.target || document);
  });
})();
